import api from "../../api/api";

export const getMedicalScheduling = data =>
  api.post("/term/medical-scheduling", data);
